import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Attach bearer token as a fallback if cookies get blocked cross-origin
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("dp_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
